import { useTranslation } from 'react-i18next';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import SEOHead from '../../components/SEO/SEOHead';

export default function NewsPage() {
  const { t } = useTranslation();

  const seoData = {
    title: 'اخبار و مقالات گلخانه سبز آریا - آخرین اخبار صنعت گلخانه‌سازی ایران',
    description: 'آخرین اخبار، مقالات تخصصی و نوآوری‌های صنعت گلخانه‌سازی ایران. اطلاعات روز دنیا درباره فناوری‌های جدید کشاورزی، روش‌های مدرن کشت و پیشرفت‌های گلخانه سبز آریا.',
    keywords: 'اخبار گلخانه، مقالات کشاورزی، اخبار صنعت گلخانه‌سازی، نوآوری‌های کشاورزی، فناوری گلخانه، اخبار آریا، مقالات تخصصی گلخانه، روش‌های مدرن کشت، پیشرفت‌های صنعت کشاورزی',
    ogImage: 'https://public.readdy.ai/ai/img_res/95dc5ac61b262633d9cb2a0ed6f36607.jpg',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "Blog",
      "name": "اخبار و مقالات گلخانه سبز آریا",
      "description": "آخرین اخبار و مقالات تخصصی صنعت گلخانه‌سازی",
      "publisher": {
        "@type": "Organization",
        "name": "گلخانه سبز آریا"
      },
      "blogPost": [
        {
          "@type": "BlogPosting",
          "headline": "نوآوری‌های جدید در صنعت گلخانه‌سازی",
          "description": "بررسی آخرین فناوری‌های کاربردی در گلخانه‌های مدرن"
        },
        {
          "@type": "BlogPosting", 
          "headline": "مزایای استفاده از سیستم‌های هوشمند در گلخانه",
          "description": "تأثیر اتوماسیون بر بهره‌وری و کیفیت محصولات"
        }
      ]
    }
  };

  const newsArticles = [
    {
      id: 1,
      title: 'راه‌اندازی بزرگترین گلخانه هوشمند کشور',
      excerpt: 'پروژه گلخانه ۱۰ هکتاری با فناوری‌های نوین در استان البرز آغاز شد',
      date: '۱۴۰۳/۰۹/۲۵',
      category: 'پروژه‌ها',
      image: 'https://readdy.ai/api/search-image?query=Largest%20smart%20greenhouse%20project%20Iran%20modern%20agricultural%20technology%20advanced%20farming%20facility%20construction%20news&width=600&height=400&seq=news-1&orientation=landscape',
      readTime: '۵ دقیقه'
    },
    {
      id: 2,
      title: 'نوآوری در سیستم‌های آبیاری قطره‌ای',
      excerpt: 'معرفی جدیدترین تکنولوژی‌های صرفه‌جویی در مصرف آب',
      date: '۱۴۰۳/۰۹/۲۰',
      category: 'فناوری',
      image: 'https://readdy.ai/api/search-image?query=Innovative%20drip%20irrigation%20systems%20water%20conservation%20technology%20modern%20agricultural%20equipment%20smart%20farming%20solutions&width=600&height=400&seq=news-2&orientation=landscape',
      readTime: '۷ دقیقه'
    },
    {
      id: 3,
      title: 'کنترل اقلیم هوشمند با هوش مصنوعی',
      excerpt: 'استفاده از الگوریتم‌های یادگیری ماشین برای بهینه‌سازی شرایط رشد',
      date: '۱۴۰۳/۰۹/۱۵',
      category: 'هوش مصنوعی',
      image: 'https://readdy.ai/api/search-image?query=AI%20climate%20control%20greenhouse%20artificial%20intelligence%20machine%20learning%20agricultural%20automation%20smart%20farming%20technology&width=600&height=400&seq=news-3&orientation=landscape',
      readTime: '۶ دقیقه'
    },
    {
      id: 4,
      title: 'گلخانه‌های عمودی؛ آینده کشاورزی شهری',
      excerpt: 'بررسی مزایا و چالش‌های کشت عمودی در فضاهای محدود شهری',
      date: '۱۴۰۳/۰۹/۱۰',
      category: 'کشاورزی شهری',
      image: 'https://readdy.ai/api/search-image?query=Vertical%20farming%20urban%20agriculture%20greenhouse%20towers%20city%20farming%20future%20technology%20sustainable%20agriculture&width=600&height=400&seq=news-4&orientation=landscape',
      readTime: '۸ دقیقه'
    },
    {
      id: 5,
      title: 'کاهش ۴۰ درصدی مصرف انرژی با تکنولوژی جدید',
      excerpt: 'معرفی سیستم‌های گرمایش و سرمایش انرژی‌کارآمد',
      date: '۱۴۰۳/۰۹/۰۵',
      category: 'انرژی',
      image: 'https://readdy.ai/api/search-image?query=Energy%20efficient%20greenhouse%20heating%20cooling%20systems%20renewable%20energy%20agricultural%20technology%20sustainable%20farming&width=600&height=400&seq=news-5&orientation=landscape',
      readTime: '۵ دقیقه'
    },
    {
      id: 6,
      title: 'صادرات محصولات گلخانه‌ای به اروپا',
      excerpt: 'افزایش ۲۵ درصدی صادرات محصولات تولیدی گلخانه‌های ایرانی',
      date: '۱۴۰۳/۰۸/۳۰',
      category: 'اقتصاد',
      image: 'https://readdy.ai/api/search-image?query=Greenhouse%20products%20export%20Europe%20Iranian%20agricultural%20exports%20international%20trade%20farming%20economy&width=600&height=400&seq=news-6&orientation=landscape',
      readTime: '۴ دقیقه'
    }
  ];

  const categories = [
    'همه',
    'پروژه‌ها',
    'فناوری',
    'هوش مصنوعی',
    'کشاورزی شهری',
    'انرژی',
    'اقتصاد'
  ];

  return (
    <div className="min-h-screen">
      <SEOHead {...seoData} />
      <Header />
      
      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center bg-cover bg-center pt-24 mt-20"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://readdy.ai/api/search-image?query=Agricultural%20news%20and%20articles%20greenhouse%20industry%20updates%20modern%20farming%20technology%20innovations%20professional%20journalism%20agricultural%20media&width=1920&height=600&seq=news-hero&orientation=landscape')`
        }}
      >
        <div className="container mx-auto px-4 lg:px-8 text-center text-white">
          <h1 className="text-5xl lg:text-6xl font-bold mb-6">
            اخبار و مقالات
          </h1>
          <p className="text-xl lg:text-2xl max-w-3xl mx-auto">
            آخرین اخبار دنیای گلخانه و کشاورزی
          </p>
        </div>
      </section>

      {/* Categories Filter */}
      <section className="py-8 bg-gray-50">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="flex flex-wrap justify-center gap-4">
            {categories.map((category, index) => (
              <button
                key={index}
                className={`px-6 py-2 rounded-full font-medium transition-colors whitespace-nowrap ${
                  index === 0 
                    ? 'bg-green-600 text-white' 
                    : 'bg-white text-gray-600 hover:bg-green-100'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* News Articles */}
      <section className="py-20">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">
              آخرین اخبار
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              جدیدترین اخبار و مقالات صنعت گلخانه
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {newsArticles.map((article) => (
              <article key={article.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                <div className="relative h-48">
                  <img 
                    src={article.image} 
                    alt={article.title}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                  <div className="absolute top-4 right-4 bg-green-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                    {article.category}
                  </div>
                </div>
                
                <div className="p-6">
                  <div className="flex items-center justify-between text-sm text-gray-500 mb-3">
                    <span className="flex items-center">
                      <i className="ri-calendar-line ml-1"></i>
                      {article.date}
                    </span>
                    <span className="flex items-center">
                      <i className="ri-time-line ml-1"></i>
                      {article.readTime}
                    </span>
                  </div>
                  
                  <h3 className="text-xl font-bold text-gray-800 mb-3 line-clamp-2">
                    {article.title}
                  </h3>
                  
                  <p className="text-gray-600 mb-4 line-clamp-3">
                    {article.excerpt}
                  </p>
                  
                  <button className="text-green-600 font-medium hover:text-green-700 transition-colors flex items-center whitespace-nowrap">
                    ادامه مطلب
                    <i className="ri-arrow-left-line mr-2"></i>
                  </button>
                </div>
              </article>
            ))}
          </div>

          {/* Load More Button */}
          <div className="text-center mt-12">
            <button className="bg-green-600 text-white px-8 py-3 rounded-lg font-medium hover:bg-green-7 00 transition-colors whitespace-nowrap">
              مشاهده مقالات بیشتر
            </button>
          </div>
        </div>
      </section>

      {/* Newsletter Subscription */}
      <section className="py-20 bg-green-600">
        <div className="container mx-auto px-4 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            عضویت در خبرنامه
          </h2>
          <p className="text-xl text-green-100 mb-8 max-w-2xl mx-auto">
            آخرین اخبار و مقالات را مستقیماً در ایمیل خود دریافت کنید
          </p>
          <div className="max-w-md mx-auto flex gap-4">
            <input 
              type="email" 
              placeholder="آدرس ایمیل شما"
              className="flex-1 px-4 py-3 rounded-lg text-gray-800 focus:outline-none focus:ring-2 focus:ring-green-300"
            />
            <button className="bg-white text-green-600 px-6 py-3 rounded-lg font-bold hover:bg-gray-100 transition-colors whitespace-nowrap">
              عضویت
            </button>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}
